import React from "react";
import Typed from "react-typed";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";

const Header = () => {
  $(function () {
    $(window).on("scroll", function () {
      var sc = $(window).scrollTop();

      if (sc > 600) {
        $(".main-info .two").fadeIn();
      } else {
        $(".main-info .two").fadeOut();
      }
    });
    $(".main-info .two").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });
    $("#home").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });
  });
  return (
    <div className="header-wrapper">
      <div className="main-info">
        <h1>Web Development And Websites Promotions</h1>
        <Typed
          className="typed-text"
          strings={["Karim Osama", "Web Designer", "Web Developer"]}
          typeSpeed={40}
          backSpeed={60}
          loop
        />
        <Link to="/contact" className="btn-contact">
          Contact Me
        </Link>
        <div className="one">
          <span>Scroll Down</span>
          <FontAwesomeIcon icon={faAngleDown} className="down" />
        </div>
        <button type="button" className="btn btn-warning two">
          <FontAwesomeIcon icon={faAngleUp} />
        </button>
      </div>
    </div>
  );
};

export default Header;
